module.exports = __webpack_public_path__ + "media/hello.9814b0e8.mp3";